export default __webpack_public_path__ + "static/media/9895CA03-7118-47BB-9B14-4C330B3C88D7.307fdd2a.jpeg";